export default __webpack_public_path__ + "static/material_01-c76772ee12023ad43c170504a624a85d.png";